<p-dialog
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  [style]="{ width: 'min(94vw, 640px)' }"
  [header]="t('print_agent_required_title', 'Chop etish dasturi kerak')"
>
  <div class="flex flex-col gap-4 text-sm text-[#344054]">
    <div
      class="flex gap-3 rounded-lg border border-amber-300 bg-amber-50 p-3 text-amber-900"
    >
      <i class="pi pi-exclamation-triangle mt-0.5"></i>
      <p>
        {{
          t(
            'print_agent_required_warning',
            "Kompyuteringizda chop etish dasturi (Print Agent) o'rnatilmagan yoki ishlamayapti. Dastursiz hujjatni chop etib bo'lmaydi."
          )
        }}
      </p>
    </div>

    <ol class="flex flex-col gap-3 list-decimal pl-5">
      <li>
        {{ t('print_agent_step_download', 'Quyidagi tugma orqali dasturni yuklab oling.') }}
        <div class="mt-2">
          <a [href]="config.downloadUrl" [attr.download]="config.fileName">
            <p-button
              icon="pi pi-download"
              [label]="t('print_agent_download', 'Dasturni yuklab olish') + ' (' + config.fileName + ')'"
              severity="primary"
              styleClass="pointer-events-none"
              tabindex="-1"
            />
          </a>
        </div>
      </li>
      <li>
        {{
          t(
            'print_agent_step_run',
            "Yuklangan faylni ikki marta bosib ishga tushiring. Windows ogohlantirish chiqarsa, \"Qo'shimcha ma'lumot\" (More info) va keyin \"Baribir ishga tushirish\" (Run anyway) tugmasini bosing."
          )
        }}
      </li>
      <li>
        {{
          t(
            'print_agent_step_firewall',
            "Windows Firewall so'rasa, \"Ruxsat berish\" (Allow access) ni tanlang."
          )
        }}
      </li>
      <li>
        {{
          t(
            'print_agent_step_printer',
            "Printeringiz kompyuterga ulangan va Windows'da o'rnatilgan bo'lishi kerak."
          )
        }}
      </li>
      <li>
        {{
          t(
            'print_agent_step_recheck',
            "Dastur ishga tushgach, pastdagi \"Qayta tekshirish\" tugmasini bosing va chop etishni takrorlang."
          )
        }}
      </li>
    </ol>

    @if (stillMissing()) {
      <p class="text-red-600">
        {{
          t(
            'print_agent_still_missing',
            "Dastur hali topilmadi. U ishga tushganini tekshirib, qayta urinib ko'ring."
          )
        }}
      </p>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="t('close', 'Yopish')"
      severity="secondary"
      (click)="close()"
    />
    <p-button
      icon="pi pi-refresh"
      [label]="t('print_agent_recheck', 'Qayta tekshirish')"
      [loading]="isChecking()"
      (click)="recheck()"
    />
  </ng-template>
</p-dialog>
